
import { Component, Vue, Prop } from "vue-property-decorator";
import { SMUser } from "@/store";
import HelloWidgetTemplate from "@/components/Widgets/Templates/HelloWidgetTemplate.vue";
import image from "@/assets/images/people/people-2.png";
import backgroundImage from "@/assets/images/widgets/background-1.png";

@Component({
  components: {
    HelloWidgetTemplate,
  },
})
export default class OnExpertReviewCandidateCosAndSwWidget extends Vue {
  @Prop({ type: String }) readonly jobTitle?: string;
  @Prop({ type: String }) readonly name?: string;
  @Prop({ type: String }) readonly caseType?: string;
  @Prop({ type: String }) readonly listType?: string;
  @Prop({ type: Boolean, default: false }) readonly getDependantVisaEnable?: boolean;

  get computedProps() {
    const { jobTitle, name, list, listType, getDependantVisaEnable } = this;

    return {
      title: this.$tc("title"),
      jobTitle,
      name,
      list,
      listType,
      image,
      backgroundImage,
      getDependantVisaEnable,
    };
  }

  get list() {
    const { caseType } = this;
    const role = SMUser.user?.role;

    if (!role) return [];

    const path = `list.${caseType}.${role}`;

    return this.$t(path) || [];
  }
}
